import React from "react";
import InputBox from "./InputBox";
import ButtonBlue from "./ButtonBlue";
import { useEffect, useState } from "react";
import {
  signupWithEmail,
  checkUser,
} from "../../utils/firebase/Firebase.utils";
import { updateUserDisplayName } from "../../utils/firebase/Firebase.utils";
import { createUserDoc } from "../../utils/firebase/Firebase.utils";
import { FaEye, FaEyeSlash, FaLock, FaEnvelope, FaUser } from "react-icons/fa";
import { MdPrivacyTip } from "react-icons/md";

import { useDispatch } from "react-redux";
import { loadUser } from "../../store/userSlice";
import { Link, useNavigate } from "react-router-dom";
import { sendEmailNotification } from "../../utils/EleghoUtils";
import toast from "react-hot-toast";
import PageModal from "../Dashboard/Components/PageModal";
import PrivacyPage from "./PrivacyPage";
import { appName, appURL, domainName } from "../../utils/constants";
import { useCompany } from "../../context/CompanyContext";
import fuegoApp from "../assets/fuegologo.jpeg";

function SignupForm() {
  const { companyData } = useCompany();
  const [formData, setFormData] = useState({});
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [emailingUser, setEmailingUser] = useState(null);
  const [emailInProgress, setEmailInProgress] = useState(false);
  const [viewMode, setViewMode] = React.useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleClickShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword((show) => !show);
  };

  const handleViewPrivacyPolicy = () => {
    setViewMode(!viewMode);
  };

  const checkDomainEmail = (email) => {
    const domain = email.split("@")[1];
    if (domain === domainName) {
      return true;
    } else {
      return false;
    }
  };

  const checkPassword = (password, confirmPassword) => {
    if (password === confirmPassword) {
      return true;
    } else {
      return false;
    }
  };

  const checkPasswordFormat = (password) => {
    const regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/;
    if (regex.test(password)) {
      return true;
    } else {
      return false;
    }
  };

  const createUserDocument = async (userAuth, additionalData) => {
    if (!userAuth) return;
    const userRef = await createUserDoc(userAuth, additionalData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsProcessing(true);
    const { displayName, email, password, confirm_password } = formData;

    if (password !== confirm_password) {
      toast.error("Passwords do not match");
      setIsProcessing(false);
      return;
    }

    const passwordCheck = checkPasswordFormat(password);
    if (!passwordCheck) {
      toast.error(
        "Password must be at least 8 characters with uppercase, lowercase, and numbers"
      );
      setIsProcessing(false);
      return;
    }

    const signUp = async () => {
      try {
        const res = await signupWithEmail(email, password);
        if (res) {
          const userCheck = await checkUser(res.user);

          if (!userCheck) {
            await createUserDoc(res.user, { displayName, roles: [] });
            dispatch(
              loadUser({ email, displayName, uid: res.user.uid, roles: [] })
            );
            navigate("/dashboard");
          } else {
            toast.error("User already exists, sign in instead");
          }
        }
      } catch (error) {
        toast.error("Failed to create account. Please try again.");
      }
    };
    signUp();

    // await sendEmailNotification(
    //   formData.displayName,
    //   formData.email,
    //   `Thank you for signing up with ${appName}`,
    //   `Welcome to ${appName}. We are excited to have you on board. Please wait for another email for the activation of your account.`,
    //   `${appURL}/login`,
    //   setEmailingUser,
    //   setEmailInProgress
    // );
    toast.success("Sign up successful. Please check your email for activation");
    setIsProcessing(false);
  };

  return (
    <div className="bg-white rounded-2xl shadow-xl p-8 w-[400px] border border-gray-100">
      <div className="flex flex-col items-center gap-6">
        <div className="flex flex-col items-center gap-4">
          <img src={fuegoApp} alt="" className="h-24" />

          <div className="title-header">{appName}</div>
          <div className="text-[#363062] text-lg font-semibold">
            Create Account
          </div>
          <div className="text-gray-500 text-sm text-center">
            Enter your details to create your account
          </div>
        </div>

        <div className="w-full">
          <form className="w-full space-y-4" onSubmit={handleSubmit}>
            <div className="relative">
              <div className="absolute top-10 left-0 pl-3 flex items-center pointer-events-none">
                <FaUser className="text-[#8FCD00] h-5 w-5" />
              </div>
              <InputBox
                label="Full Name"
                type="text"
                placeholder="Enter your full name"
                onChange={handleChange}
                name="displayName"
                className="pl-10"
              />
            </div>

            <div className="relative">
              <div className="absolute top-10 left-0 pl-3 flex items-center pointer-events-none">
                <FaEnvelope className="text-[#8FCD00] h-5 w-5" />
              </div>
              <InputBox
                label="Email Address"
                type="email"
                placeholder="Enter your email address"
                onChange={handleChange}
                name="email"
                className="pl-10"
              />
            </div>

            <div className="relative">
              <div className="absolute top-10 left-0 pl-3 flex items-center pointer-events-none">
                <FaLock className="text-[#8FCD00] h-5 w-5" />
              </div>
              <InputBox
                label="Password"
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                onChange={handleChange}
                name="password"
                className="pl-10"
              />
              <button
                type="button"
                className="absolute top-10 right-2 flex items-center text-gray-400 hover:text-[#363062]"
                onClick={handleClickShowPassword}
              >
                {showPassword ? (
                  <FaEyeSlash className="h-5 w-5" />
                ) : (
                  <FaEye className="h-5 w-5" />
                )}
              </button>
            </div>

            <div className="relative">
              <div className="absolute top-10 left-0 pl-3 flex items-center pointer-events-none">
                <FaLock className="text-[#8FCD00] h-5 w-5" />
              </div>
              <InputBox
                label="Confirm Password"
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm your password"
                onChange={handleChange}
                name="confirm_password"
                className="pl-10"
              />
              <button
                type="button"
                className="absolute top-10 right-2 flex items-center text-gray-400 hover:text-[#363062]"
                onClick={handleClickShowConfirmPassword}
              >
                {showConfirmPassword ? (
                  <FaEyeSlash className="h-5 w-5" />
                ) : (
                  <FaEye className="h-5 w-5" />
                )}
              </button>
            </div>

            <button
              type="submit"
              className={`w-full py-3 px-4 rounded-lg text-white font-medium transition-colors ${
                isProcessing
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#363062] hover:bg-[#2a2450]"
              }`}
              disabled={isProcessing}
            >
              {isProcessing ? "Creating Account..." : "Create Account"}
            </button>

            <div className="text-center text-sm text-gray-600">
              Already have an account?{" "}
              <Link
                to="/login"
                className="text-[#8FCD00] hover:text-[#363062] font-medium"
              >
                Sign in
              </Link>
            </div>

            <div
              className="text-center text-sm text-gray-600 cursor-pointer hover:text-[#363062] flex items-center justify-center gap-1"
              onClick={handleViewPrivacyPolicy}
            >
              <MdPrivacyTip className="h-4 w-4" />
              By signing up, you agree to our Terms and Privacy Policy
            </div>
          </form>

          {viewMode && (
            <PageModal>
              <PrivacyPage setViewMode={setViewMode} />
            </PageModal>
          )}
        </div>
      </div>
    </div>
  );
}

export default SignupForm;
